/**
 * This is used to avoid conflicts with other platforms.
 * E.g. "sonic" is both a chain and an exchange on Coingecko.
 */
export var PlatformPrefix;
(function (PlatformPrefix) {
    PlatformPrefix["Chain"] = "chain.";
    PlatformPrefix["Exchange"] = "ex.";
    PlatformPrefix["App"] = "app.";
    PlatformPrefix["Gov"] = "gov.";
})(PlatformPrefix || (PlatformPrefix = {}));
//# sourceMappingURL=config.js.map